// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fast-track-modal__header .close{text-align:right;width:32px;height:32px}.fast-track-modal__content{border-radius:0}@media(min-width:0)and (max-width:767px){.fast-track-modal__content{margin-left:16px;margin-right:16px}}.fast-track-modal__content-body{padding:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
